import {
  FETCH_RELEASEDS_SUCCESS,
  FETCH_RELEASEDS_REQUEST,
  FETCH_RELEASEDS_FAILURE,
  UPDATE_RELEASED_REQUEST,
  UPDATE_RELEASED_SUCCESS,
  UPDATE_RELEASED_FAILURE,
  SHOW_RELEASED_EDIT_FORM,
  DELETE_RELEASED_REQUEST,
  DELETE_RELEASED_SUCCESS,
  DELETE_RELEASED_FAILURE,
  SET_RELEASED_VALIDATION_ERRORS,
  SHOW_RELEASED_NEW_FORM,
  CREATE_RELEASED_REQUEST,
  CREATE_RELEASED_SUCCESS,
  CREATE_RELEASED_FAILURE,
} from "constants/Released";
import {changeDateToHumanReadableFormat} from "../../utils/DateTimeUtil"

const initState = {
  loading: false,
  list: [],
  errorMessage: "",
};

const released = (state = initState, action) => {
  switch (action.type) {
    case FETCH_RELEASEDS_REQUEST:
      return {
        ...state,
        loading: true,
        showEditForm: false,
        showNewForm: false,
      };
    case FETCH_RELEASEDS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: changeDateToHumanReadableFormat(action.payload),
      };
    case FETCH_RELEASEDS_FAILURE:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };

    default:
      return state;
  }
};

export default released;
